export default "__VITE_ASSET__Bkg0dWH7__"